import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../components/ui/Button";

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "60vh",
                padding: "40px 20px",
                textAlign: "center",
            }}
        >
            <h1
                style={{
                    fontSize: "120px",
                    fontWeight: "bold",
                    color: "var(--green-600)",
                    margin: 0,
                    lineHeight: 1,
                }}
            >
                404
            </h1>
            <h2
                style={{
                    fontSize: "24px",
                    color: "#1a1a2e",
                    marginTop: "16px",
                    marginBottom: "8px",
                }}
            >
                {t("pageNotFound") || "Page Not Found"}
            </h2>
            <p
                style={{
                    fontSize: "16px",
                    color: "#666",
                    marginBottom: "32px",
                    maxWidth: "400px",
                }}
            >
                {t("pageNotFoundDescription") ||
                    "The page you are looking for does not exist or you don't have access to it."}
            </p>
            <Button label={t("backToHome") || "Back to Home"} onClick={() => navigate("/")} variant="primary" />
        </div>
    );
};

export default NotFoundPage;
